import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

interface ChatbotConfigHeaderProps {
  chatbot: any;
  onBack: () => void;
}

const ChatbotConfigHeader: React.FC<ChatbotConfigHeaderProps> = ({ chatbot, onBack }) => {
  return (
    <div className="bg-white/80 backdrop-blur-sm border-b border-white/30 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <button
              onClick={onBack}
              className="p-2 text-agentic-text-secondary hover:text-agentic-text-primary transition-colors"
              aria-label="Go back"
            >
              <ArrowLeftIcon className="h-5 w-5" />
            </button>
            <div>
              <h1 className="text-3xl font-bold bg-gradient-to-r from-agentic-text-primary via-agentic-primary-blue to-agentic-accent-purple bg-clip-text text-transparent">
                {chatbot?.name || 'Chatbot'}
              </h1>
              <p className="mt-1 text-agentic-text-secondary">{chatbot?.description}</p>
            </div>
          </div>
          <div className="text-sm text-agentic-text-secondary">
            Last updated:{' '}
            {chatbot?.updatedAt
              ? new Date(chatbot.updatedAt).toLocaleString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              : 'N/A'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatbotConfigHeader;
